/**
 * NAV1 — konwencja powrotu (returnTo) dla nawigacji dotykowej / PWA.
 * Priorytet powrotu: state.returnTo → ?from= → history.back() → logiczny rodzic → fallback.
 * `resolveBack` jest czyste (bez nawigacji) — do testów. `goBack` wykonuje nawigację.
 */

// Ekrany-korzenie (dostępne wprost z paska): tam NIE pokazujemy przycisku wstecz.
export const ROOT_PATHS = ['/dashboard', '/calendar', '/plants', '/plots', '/feed', '/menu'];

// Logiczni rodzice — dokładne ścieżki (fallback gdy brak returnTo/from/historii).
const EXACT_PARENTS = {
  '/znajomi': '/feed',
  '/gielda': '/feed',
  '/tasks': '/calendar',
};

// Logiczni rodzice — prefiksy stron szczegółów (np. /plants/123 → /plants).
const PREFIX_PARENTS = [
  ['/plants/', '/plants'],
  ['/plots/', '/plots'],
  ['/gallery/', '/gallery'],
  ['/g/', '/feed'],
  ['/ogrod-znajomego/', '/znajomi'],
  ['/problemy/', '/problemy'],
];

export function isRootScreen(pathname) {
  return ROOT_PATHS.includes(pathname);
}

function getLogicalParent(pathname) {
  if (EXACT_PARENTS[pathname]) return EXACT_PARENTS[pathname];
  for (const [prefix, parent] of PREFIX_PARENTS) {
    if (pathname.startsWith(prefix)) return parent;
  }
  return null;
}

/**
 * Rozwiązuje docelową ścieżkę powrotu BEZ nawigacji (testowalne).
 * Nie uwzględnia history.back() (nie da się go zredukować do ścieżki) — od tego jest goBack.
 */
export function resolveBack(location, fallback = '/dashboard') {
  if (location?.state?.returnTo) return location.state.returnTo;
  const from = new URLSearchParams(location?.search || '').get('from');
  if (from) return from;
  return getLogicalParent(location?.pathname || '') || fallback;
}

/** Wykonuje powrót zgodnie z konwencją NAV1. */
export function goBack(navigate, location, fallback = '/dashboard') {
  if (location?.state?.returnTo) { navigate(location.state.returnTo); return; }
  const from = new URLSearchParams(location?.search || '').get('from');
  if (from) { navigate(from); return; }
  // Historia przeglądarki, jeśli w ogóle jest (w PWA standalone bywa krótka).
  if (typeof window !== 'undefined' && window.history.length > 1) { navigate(-1); return; }
  navigate(getLogicalParent(location?.pathname || '') || fallback);
}
